__webpack_require__.p = "https://oss-assets.amberstudent.cn/amber-user-website/VP1-8.50.8-7ed9-amber-user-website-prod-hk-1781/assets/";